module.exports = __webpack_public_path__ + "static/media/linkiedin-iconTenerif.3b3acd16.png";